'use strict';

/**
 * Dismissible cart messages.
 *
 * Informational / promotional messages rendered by components/message.isml with
 * data-dismissible="true" can be closed via their "X" button. A dismissal is stored
 * in sessionStorage keyed by the message key together with a content hash so that:
 *   - the message stays hidden for the rest of the browser session,
 *   - it re-appears in a new session (sessionStorage is cleared),
 *   - it re-appears within the same session if its content (hash) changes.
 */

var JSConstants = require('_core_ext/pages/cart/constants');
var CSSConstants = require('_core_ext/cssconstants');

/**
 * @returns {Storage|null} the sessionStorage object or null when unavailable
 */
function getStore() {
    try {
        return window.sessionStorage;
    } catch (e) {
        return null;
    }
}

/**
 * @returns {Object} map of dismissed message keys to their stored content hash
 */
function readDismissed() {
    var store = getStore();

    if (!store) {
        return {};
    }

    try {
        return JSON.parse(store.getItem(JSConstants.SS_KEY_DISMISSED_MESSAGES)) || {};
    } catch (e) {
        return {};
    }
}

/**
 * @param {Object} dismissed - map of dismissed message keys to content hash
 */
function writeDismissed(dismissed) {
    var store = getStore();

    if (!store) {
        return;
    }

    try {
        store.setItem(JSConstants.SS_KEY_DISMISSED_MESSAGES, JSON.stringify(dismissed));
    } catch (e) {
        // storage unavailable / quota exceeded - dismissal simply will not persist
    }
}

/**
 * Hides any dismissible message whose stored hash still matches its current content.
 */
function hideDismissedMessages() {
    var dismissed = readDismissed();

    $(JSConstants.CLASS_CART_MESSAGE + '[data-dismissible="true"]').each(function () {
        var $message = $(this);
        var key = $message.attr('data-message-key');
        var hash = $message.attr('data-message-hash') || '';

        if (key && Object.prototype.hasOwnProperty.call(dismissed, key) && String(dismissed[key]) === hash) {
            $message.addClass(CSSConstants.HIDDEN);
        }
    });
}

/**
 * Click handler for the close ("X") button.
 */
function dismissMessage() {
    var $message = $(this).closest(JSConstants.CLASS_CART_MESSAGE);
    var key = $message.attr('data-message-key');
    var hash = $message.attr('data-message-hash') || '';

    $message.addClass(CSSConstants.HIDDEN);

    if (key) {
        var dismissed = readDismissed();
        dismissed[key] = hash;
        writeDismissed(dismissed);
    }
}

function init() {
    hideDismissedMessages();
    $(document).on('click', JSConstants.CLASS_CART_MESSAGE_CLOSE, dismissMessage);
}

module.exports = {
    init: init
};
